import React, { createRef } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import HomeIcon from '@material-ui/icons/Home';
import ImageIcon from '@material-ui/icons/Image';
import MessageIcon from '@material-ui/icons/NotificationsNoneOutlined';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import LogoutIcon from '@material-ui/icons/Undo';
import LocalGroceryStoreOutlinedIcon from '@material-ui/icons/LocalGroceryStoreOutlined';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ShareIcon from '@material-ui/icons/Share';
import GetAppIcon from '@material-ui/icons/GetApp';
import CameraAltOutlinedIcon from '@material-ui/icons/CameraAltOutlined';
import ImportContactsOutlinedIcon from '@material-ui/icons/ImportContactsOutlined';
import AddToPhotosOutlinedIcon from '@material-ui/icons/AddToPhotosOutlined';
import CreateIcon from '@material-ui/icons/Create';
import CloseIcon from '@material-ui/icons/Close';
import DynamicFeedIcon from '@material-ui/icons/DynamicFeed';
import RefreshIcon from '@material-ui/icons/Refresh';
import messages, { FormattedMessage, withValues } from 'shared/messages/messages';
import { Form, Button, Ref, Divider, Header } from 'semantic-ui-react';
import NavItem from 'shared/components/NavItem';
import Modal from 'shared/components/Modal';

import {
  showNavBar,
  hideNavBar,
  showNavBarModal,
  showNavBarHome,
  showNavBarFeed,
  logOut,
} from 'shared/actions/navActions';

import {
  NAV_BAR_HOME,
  NAV_BAR_STORY,
  NAV_BAR_PRINT_STORE,
  NAV_BAR_MODAL,
  NAV_BAR_FEED,
} from 'shared/actions/types';

import {
  loadStories,
  createStory,
  selectStory,
} from 'shared/actions/storyActions';

import {
  enableSelection,
  disableSelection,
  selectAll,
  unselectAll
} from 'shared/actions/selectionActions';

import {
  setProgressBarVisible,
  setProgressBarTotal,
  setProgressBarProgress,
  setProgressBarMessage,
  resetProgressBar
} from 'shared/actions/progressBarActions';

import {
  showProfile,
  showStory,
  showLoading
} from 'shared/actions/homeActions';

import {
  downloadStory,
  downloadUrl
} from 'shared/services/DownloadService'

import {
  createSharePage
} from 'shared/services/ShareService';

import {
  STORY_DOWNLOAD_URL
} from 'shared/utils/Constants';

// import { Braze } from 'shared/services/Braze';
import config from 'shared/config/config';

import {
  trackEvent
} from 'shared/services/Analytics';

import UserService from 'shared/services/UserService';
import zIndex from '@material-ui/core/styles/zIndex';
import modalStyles from './modalStyles';

const isMobile = window.innerWidth < 960;

const userService = new UserService();

const styles = theme => ({
  nav: {
    position: 'fixed',
    zIndex: 9998,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    padding: isMobile ? '5px' : '1rem',
    background: config.pwa_navbar_bg_color,
    boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.2)',
    border: '2px solid ' + config.pwa_navbar_border_color
  },
  brand: {
    height: 'auto',
    width: 'auto',
    marginTop: '20px',
    marginBottom: '40px'
  },
  form: {
    position: 'relative',
    zIndex: 2,
    width: '100%',
    background: '#fff',
    padding: '2rem 1rem',
    margin: '20vh auto 0',
    boxShadow: '3px 3px 20px rgba(0, 0, 0, 0.5)',
    maxWidth: '600px',
    borderRadius: isMobile ? 0 : '3px'
  },
  formBackdrop: {
    position: 'fixed',
    zIndex: 1,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5))'
  },
  closeIcon: {
    position: 'absolute',
    top: '5px',
    right: '5px',
    color: '#949494',
    opacity: 0.5,
    cursor: 'pointer',
    '&:hover': {
      opacity: 1
    }
  },
  button: {
    border: 'none',
    borderRadius: '3px',
    background: '#000',
    color: '#fff',
    fontWeight: 600,
    fontSize: '1.2rem',
    padding: '0.5rem 1rem',
    width: '100%',
    marginTop: '1rem'
  },
  legalNotesLabel: {
    color: 'white',
    marginBottom: '0px',
    fontSize: '9px',
    fontFamily: config.sub_font,
  },
  legalNotesPanel: {
    position: 'fixed',
    zIndex: 9999,
    padding: '8px',
    textAlign: 'center'
  },
  navBarItem: {
    width: '100%',
    background: config.pwa_navbar_item_bg_color,
    fontFamily: config.sub_font,
    marginTop: '1rem',
    fontSize: '1.2rem',
    padding: '0.5rem 0 0.7rem'
  },
  inputGroup: {
    padding: '0.3rem 0'
  },
  errorStyle: {
    background: '#ff7979',
    color: '#eb4d4b'
  },
  ...modalStyles()
});

class Nav extends React.Component {
  constructor(props) {
    super(props);

    this.fileInput = createRef();
    this.storyNameInput = createRef();

    this.state = {
      newStoryIsOpen: false,
      storyShareIsOpen: false
    }
  }

  componentDidMount() {
    window.navComponent = this;
  }

  componentDidUpdate() {
    // setup Add Photos button
    if (this.fileInput.current) {
      this.fileInput.current.style.position = 'absolute';
      this.fileInput.current.style.opacity = 0;
      this.fileInput.current.style.pointerEvents = 'none';
      this.fileInput.current.style.width = 0;
      this.fileInput.current.style.height = 0;
    }

    // autofocus new story name input
    if (this.state.newStoryIsOpen && this.storyNameInput.current) {
      this.storyNameInput.current.focus();
    }
  }

  openNewStory() {
    this.setState({ newStoryIsOpen: true });
    this.props.showNavBarModal();
  }

  closeNewStory() {
    this.setState({ newStoryIsOpen: false });
    this.props.showNavBarHome();

    // hotfix
    document.body.style.overflowY = 'scroll';
  }

  closeNewStoryModal() {
    let q = {};
    q.promise = new Promise((resolve, reject) => {
      q.resolve = resolve;
      q.reject = reject;
    });

    window.currentModal.close();
    setTimeout(() => {
      this.closeNewStory();
      q.resolve();
    }, 500);

    return q.promise;
  }

  createStory = event => {
    alert('needs to be fixed, old code obsolete');
    if (1 === 1) {
      return;
    }

    event.preventDefault();

    let input = this.storyNameInput.current;
    if (!input.value) {
      // show error
      input.style.borderColor = 'red';
      input.onkeypress = () => input.style.borderColor = '#ced4da';
      return;
    }

    const form = event.currentTarget;
    const name = form.elements[0].value;

    let params = {
      name: name
    }

    this.props.createStory(params)
      .then(story => {
        this.closeNewStoryModal()
          .then(() => {
            // hotfix
            //window.CL.storyComponents[story.id].open();
          });
      })
      .catch(err => console.error(err));
  }

  onClickBack = event => {
    event.preventDefault();

    window.currentMomentsScreen.close();
    this.props.disableSelection();

    //// hotfix to close all modals
    //for (let modal of window.modals) {
    //  setTimeout(() => modal.close());
    //}

    //// hotfix
    //document.body.style.overflowY = 'auto';
  }

  onClickStoryBack = event => {
    event.preventDefault();

    window.currentMomentsScreen.close();

    // hotfix to close all modals
    //for (let modal of window.modals) {
    //  setTimeout(() => modal.close());
    //}
  }

  onClickModalBack = event => {
    event.preventDefault();
    window.currentModal.close();
  }

  onClickHome = event => {
    event.preventDefault();
    this.props.showStory();
    window.scrollTo(0, 0);
    window.currentMomentsScreen.close();
    this.props.showStory();
  }

  onClickFeed = event => {
    event.preventDefault();
    // Braze.display.toggleFeed();
    this.props.showNavBarFeed();

    // if showing the Braze toolbar, use this to listen to close button
    //setTimeout(() => {
    //  const closeBtn = document.querySelector('.ab-close-button');
    //  if (closeBtn) {
    //    closeBtn.addEventListener('click', () => this.props.showNavBarHome());
    //  }
    //}, 200);
  }

  onClickLogout = event => {
    this.props.showLoading(true);
    userService.logout().then((resp) => {
      this.props.showLoading(false);
      this.props.logOut();
      window.location = "/login";
    })
  }

  onClickFeedBack = event => {
    event.preventDefault();
    // Braze.display.toggleFeed();
    this.props.showNavBarHome();
  }

  onClickFeedRefresh = event => {
    event.preventDefault();
    const btn = document.querySelector('.ab-refresh-button');
    if (btn) {
      btn.click();
    }
  }

  onClickProfile = event => {
    event.preventDefault();
    this.props.showProfile();
  }

  onClickEditStory = event => {
    event.preventDefault();
    window.currentMomentsScreen.openEdit();
  }

  onClickAddStory = event => {
    event.preventDefault();

    this.openNewStory();
  }

  onClickInbox = event => {
    event.preventDefault();
    console.log(this.props.nav);
  }

  onClickShare = event => {
    event.preventDefault();

    const header = <FormattedMessage {...messages.consumer_nav_share} />;
    const buttonText = <FormattedMessage {...messages.consumer_nav_share} />;
    const buttonIcon = <ShareIcon />;
    const cancel = () => {
      this.props.unselectAll();
      this.props.disableSelection();
      this.props.showNavBar();
    }
    const callback = () => {
      const {
        user,
        stories,
        selectionItems,
        //gallery,
        openStoryId,
        storyMoments
      } = this.props;

      const story = stories.byId[openStoryId];
      const momentIds = storyMoments[openStoryId];
      let selectedMoments = momentIds
        .filter(id => selectionItems[id]);

      if (!selectedMoments.length) {
        selectedMoments = storyMoments[openStoryId];
      }

      createSharePage(story.id, selectedMoments)
        .then(page => {
          if (navigator.share) {
            let params = {
              url: page.url,
              title: page.story_name,
              text: page.provider_name
            }

            navigator.share(params)
              .then(() => {
                trackEvent('Share', {
                  source: 'navigator',
                  userId: user && user.id,
                  storyId: story.id,
                  storyName: story.name,
                  momentIds: selectedMoments,
                  shareUrl: page.url,
                  sharePageId: page.id
                });

                cancel();
              });
          } else {
            alert(page.url);

            trackEvent('Share', {
              source: 'desktop',
              userId: user.id,
              storyId: story.id,
              storyName: story.name,
              momentIds: selectedMoments,
              shareUrl: page.url,
              sharePageId: page.id
            });

            cancel();
          }
        });
    }

    this.props.enableSelection(header, buttonText, buttonIcon, callback, cancel);
    this.props.hideNavBar();
    this.props.selectAll();
  }

  onClickDownload = event => {
    event.preventDefault();

    const header = <FormattedMessage {...messages.consumer_nav_download} />;;
    const buttonText = <FormattedMessage {...messages.consumer_nav_download} />;
    const buttonIcon = <GetAppIcon />;
    const cancel = () => {
      this.props.unselectAll();
      this.props.disableSelection();
      this.props.showNavBar();
    }
    const callback = allSelected => {
      const {
        user,
        stories,
        selectionItems,
        gallery,
        setProgressBarVisible,
        setProgressBarTotal,
        setProgressBarMessage,
        setProgressBarProgress,
        resetProgressBar,
        openStoryId,
        storyMoments,
        moments
      } = this.props;

      const story = stories.byId[openStoryId];
      const momentIds = storyMoments[openStoryId];
      const selectedMoments = momentIds
        .filter(id => selectionItems[id])
        .map(id => moments.byId[id]);

      let selectedMomentIds = selectedMoments.map(m => m.id);

      if (selectedMoments.length === 1) {
        const moment = selectedMoments[0];
        const ext = (moment.type && moment.type.split("/")[1]) || 'jpeg';

        downloadUrl(`image-${moment.id}.${ext}`, moment.download_url)
          .then(() => {
            trackEvent('Download', {
              storyId: story.id,
              storyName: story.name,
              moments: `${selectedMomentIds.length}/${momentIds.length}`
            });

            cancel();
          });
      } else {
        let promise;
        if (allSelected) {
          promise = downloadStory(story);
        } else {
          promise = downloadStory(story, selectedMomentIds);
        }

        promise
          .then(() => {
            trackEvent('Download', {
              userId: user.id,
              storyId: story.id,
              storyName: story.name,
              moments: `${selectedMomentIds.length}/${momentIds.length}`
            });

            cancel();
          });
      }
    }

    this.props.enableSelection(header, buttonText, buttonIcon, callback, cancel);
    this.props.hideNavBar();
    this.props.selectAll();
  }

  onClickPrintStore = event => {
    window.currentMomentsScreen.openPrintStore();
    event.preventDefault();
  }

  addMomentsToStory = event => {
    // hotfix
    window.currentMomentsScreen.addMomentsToStory(event);
  }

  renderBrand = classes => {
    if (!isMobile) {
      return (
        <img className={classes.brand} src={this.getTopBarLogo()} />
      )
    }
  }

  getTopBarLogo() {
    const { user } = this.props;
    let locale = 'en-us';
    if (user) {
      locale = user.locale
    }

    if (locale && locale.includes("de")) {
      return config.pwa_navbar_desktop_brand_logo_german;
    } else if (locale && locale.includes("fr")) {
      return config.pwa_navbar_desktop_brand_logo_french;
    } else {
      return config.pwa_navbar_desktop_brand_logo;
    }
  }

  renderBack = classes => {
    if (!isMobile) {
      return (
        <NavItem label={<FormattedMessage {...messages.consumer_nav_back} />} onClick={this.onClickBack} >
          <ArrowBackIcon />
        </NavItem >
      )
    }
  }

  renderStoryName = classes => {
    // hotfix
    let story = window.currentMomentsScreen.props.story;

    if (!isMobile && story) {
      return (
        <h1 style={{ fontSize: '1.2rem', padding: '1rem 0', fontWeight: 400 }}><b style={{ fontWeight: 500 }}>{story.name}</b> ({story.moments_count})</h1>
      )
    }
  }

  renderStoryHome = (classes, iconStyle) => {
    if (isMobile) {
      return (
        <NavItem label={<FormattedMessage {...messages.consumer_nav_home} />} onClick={this.onClickStoryBack} iconStyle={iconStyle}>
          <HomeIcon />
        </NavItem>
      )
    }
  }

  renderShare = (classes, iconStyle) => {
    return (
      <NavItem label={<FormattedMessage {...messages.consumer_nav_share} />}
        onClick={this.onClickShare}
        iconStyle={iconStyle}>
        <ShareIcon />
      </NavItem>
    );
  }

  renderAddPhotos() {
    if (config.mlb) {
      return null;
    }

    const owner = !this.props.user.anonymous;
    const story = window.currentMomentsScreen && window.currentMomentsScreen.props.story;
    const accountSettings = story && this.props.accountSettings[story.id];
    const enabled = owner && accountSettings && !accountSettings.disable_add_photo;

    let navLabel = <FormattedMessage {...messages.consumer_nav_add_photos} />
    if (isMobile) {
      navLabel = <FormattedMessage {...messages.consumer_nav_add_photos_mobile} />
    }

    if (enabled) {
      return (
        <NavItem label={navLabel}
          onClick={() => this.fileInput.current.click()}>
          <input type="file" accept="image/*" id="file" multiple ref={this.fileInput} onChange={this.addMomentsToStory} />
          <CameraAltOutlinedIcon />
        </NavItem>
      );
    }

    return null;
  }

  renderDownload = (classes, iconStyle) => {
    if (!window.currentMomentsScreen || config.mlb) {
      return null;
    }

    return (
      <NavItem label={<FormattedMessage {...messages.consumer_nav_download} />}
        iconStyle={iconStyle}
        onClick={this.onClickDownload.bind(this)}>
        <GetAppIcon />
      </NavItem>
    );
  }

  renderPrintStore = (classes, iconStyle) => {
    if (config.mlb) {
      return null;
    }

    const accountSettings = this.props.accountSettings[this.props.openStoryId];
    const enabled = accountSettings && !accountSettings.disable_print_store;

    if (enabled) {
      // this disabled stuff is for new stories, which aren't active
      //const moments = window.currentMomentsScreen.loadCachedMoments();
      //const disabled = !moments.length;
      const disabled = false;

      if (accountSettings.new_tab) {
        return (
          <NavItem label={<FormattedMessage {...messages.consumer_nav_print_store} />}
            disabled={disabled}
            href={accountSettings.print_store_url}
            iconStyle={iconStyle}>
            <LocalGroceryStoreOutlinedIcon />
          </NavItem>
        );
      } else {
        return (
          <NavItem label={<FormattedMessage {...messages.consumer_nav_print_store} />}
            disabled={disabled}
            onClick={this.onClickPrintStore}
            iconStyle={iconStyle}>
            <LocalGroceryStoreOutlinedIcon />
          </NavItem>
        );
      }
    }

    return null;
  }

  renderEditStory = classes => {
    if (this.props.user.anonymous) {
      return null;
    }

    if (!isMobile) {
      return (
        <NavItem label="Edit Story" onClick={this.onClickEditStory}>
          <CreateIcon />
        </NavItem>
      )
    }
  }

  renderNewStoryDialog = classes => {
    return (
      <Modal disableScrollbar={true}
        isOpen={this.state.newStoryIsOpen}
        close={this.closeNewStory.bind(this)}>
        <div className={classes.formBackdrop}></div>
        <div className={classes.form}>
          <CloseIcon className={classes.closeIcon} onClick={this.closeNewStory.bind(this)} />
          <Form onSubmit={this.createStory}>
            <h1 style={{ fontSize: '1.5rem' }}>New Story</h1>
            <h2 className={this.state.error ? 'error' : ''}>{this.state.message}</h2>
            <Form.Group>
              <Form.Label for="name" style={{ textAlign: 'left', fontWeight: 500, width: '100%' }}>Story name</Form.Label>
              <Form.Control ref={this.storyNameInput}
                className={this.state.nameError ? 'error' : ''}
                type="text"
                name="name"
                placeholder="Story name"
              />
            </Form.Group>
            <Button variant="primary" className="bs-btn bs-btn-primary full-width" style={{ width: '100%', background: '#000', marginTop: '1rem', fontSize: '1.2rem', padding: '0.5rem 0 0.7rem' }} type="submit">
              <span>{this.state.submitting ? 'Creating...' : 'Create'}</span>
            </Button>
          </Form>
        </div>
      </Modal>
    );
  }

  renderNavBarHome = (classes, style) => {
    let addStory = null;
    //if (!this.props.user.anonymous) {
    //  addStory = (
    //    <NavItem label={isMobile ? 'Add' : 'Add Story'} onClick={this.onClickAddStory}>
    //      <AddToPhotosOutlinedIcon />     
    //    </NavItem>
    //  );
    //}

    let enabledProfile = false
    for (let storyId in this.props.accountSettings) {
      if (!this.props.accountSettings[storyId].disable_profile_page) {
        enabledProfile = true
        break
      }
    }

    return (
      <div>
        <div className={classes.nav} style={style}>
          {this.renderBrand(classes)}
          <NavItem label={<FormattedMessage {...messages.consumer_nav_home} />} onClick={this.onClickHome}>
            <HomeIcon />
          </NavItem>
          {addStory}
          {
            enabledProfile &&
            <NavItem label={<FormattedMessage {...messages.consumer_nav_profile} />} onClick={this.onClickProfile}>
              <PersonOutlineIcon />
            </NavItem>
          }
          <NavItem label={<FormattedMessage {...messages.consumer_nav_logout} />} onClick={this.onClickLogout}>
            <LogoutIcon />
          </NavItem>
        </div>
      </div>
    )
  }

  renderNavBarFeed = (classes, style) => {
    return (
      <div>
        <div className={classes.nav} style={style}>
          {this.renderBrand(classes)}
          <NavItem label={<FormattedMessage {...messages.consumer_nav_back} />} onClick={this.onClickFeedBack}>
            <ArrowBackIcon />
          </NavItem>
          <NavItem label={<FormattedMessage {...messages.consumer_nav_refresh} />} onClick={this.onClickFeedRefresh}>
            <RefreshIcon />
          </NavItem>
        </div>
      </div>
    )
  }

  //renderNavBarStory = (classes, style) => {
  //  style = Object.assign({}, style);
  //  if (isMobile) {
  //    style.padding = '10px 0';
  //  }

  //  return (
  //    <div id="navbar" className={classes.nav} style={style}>
  //      { this.renderBrand(classes) }
  //      { this.renderBack(classes) }
  //      { this.renderStoryHome(classes) }
  //      <NavItem label="Share" onClick={this.onClickShare}>
  //        <ShareIcon />
  //      </NavItem>
  //      <NavItem label="Download" onClick={this.onClickDownload}>
  //        <GetAppIcon />
  //      </NavItem>
  //      { this.renderEditStory(classes) }
  //      <NavItem label="Add Photos" onClick={() => this.fileInput.current.click()}>
  //        <input type="file" accept="image/*" id="file" multiple ref={this.fileInput} onChange={this.addMomentsToStory} />
  //        <CameraAltOutlinedIcon />
  //      </NavItem>
  //      <NavItem label="Print Store" onClick={this.onClickPrintStore}>
  //        <ImportContactsOutlinedIcon />
  //      </NavItem>
  //      <NavItem label="Inbox" onClick={this.onClickInbox}>
  //        <MailOutlineIcon />
  //      </NavItem>
  //    </div>
  //  )
  //}

  renderNavBarStory = (classes, style) => {
    style = Object.assign({}, style);

    const iconStyle = {
      maxWidth: '100%',
      color: config.pwa_navbar_font_color
    }

    return (
      <div>
        <div id="navbar" className={classes.nav} style={style}>
          {this.renderBrand(classes)}
          {this.renderBack(classes)}
          {this.renderStoryHome(classes, iconStyle)}
          {this.renderShare(classes, iconStyle)}
          {this.renderDownload(classes, iconStyle)}
          {this.renderPrintStore(classes, iconStyle)}
          {this.renderAddPhotos()}
        </div>
      </div>
    )
  }
  
  renderNavBarPrintStore = (classes, style) => {
    style = Object.assign({}, style);
    if (isMobile) {
      style.padding = '10px 0';
      style.justifyContent = 'flex-start';
    }

    return (
      <div>
        <div id="navbar" className={classes.nav} style={style}>
          {this.renderBrand(classes)}
          <NavItem label={<FormattedMessage {...messages.consumer_nav_back} />} onClick={this.onClickModalBack}>
            <ArrowBackIcon />
          </NavItem>
        </div>
      </div>
    )
  }

  renderNavBarModal = (classes, style) => {
    style = Object.assign({}, style);
    if (isMobile) {
      style.padding = '10px 0';
      style.justifyContent = 'flex-start';
    }

    return (
      <div>
        <div id="navbar" className={classes.nav} style={style}>
          {this.renderBrand(classes)}
          <NavItem label={<FormattedMessage {...messages.consumer_nav_back} />} onClick={this.onClickModalBack}>
            <ArrowBackIcon />
          </NavItem>
        </div>
      </div>
    )
  }

  render() {
    const { user, classes, disabled } = this.props;

    if (disabled) {
      return null;
    }

    var style = isMobile ? {
      left: 0,
      right: 0,
      bottom: 0,
      //height: '53px',
      //height: '60px',
      height: '100px',
      borderTop: '1px solid #ccc',
      transition: 'bottom 0.5s',
    } : {
      flexDirection: 'column',
      justifyContent: 'start',
      textAlign: 'left',
      top: 0,
      left: 0,
      bottom: 0,
      width: '20vw'
    }

    var legalNoteStyle = !isMobile ? {
      width: '20vw',
      left: 0,
      bottom: 0,
    } : {
      left: 0,
      right: 0,
      bottom: 0,
    }

    if (this.props.photoSwipeOpen !== false) {
      legalNoteStyle.width = '100%';
    }

    if (this.props.nav.hidden) {
      if (isMobile) {
        style.bottom = '-20em';
        legalNoteStyle.width = '100%';
        legalNoteStyle.bottom = '-20em';
      } else {
        style.zIndex = 9997;
      }
    }

    var navBar;
    switch (this.props.nav.state) {
      case NAV_BAR_HOME:
        navBar = this.renderNavBarHome(classes, style);
        break;

      case NAV_BAR_STORY:
        navBar = this.renderNavBarStory(classes, style);
        break;

      case NAV_BAR_PRINT_STORE:
        navBar = this.renderNavBarPrintStore(classes, style);
        break;

      case NAV_BAR_MODAL:
        navBar = this.renderNavBarModal(classes, style);
        break;

      case NAV_BAR_FEED:
        navBar = this.renderNavBarFeed(classes, style);
        break;
    }

    return (
      <div style={{ color: config.pwa_navbar_font_color }}>
        {navBar}
        {this.renderNewStoryDialog(classes)}
        {
          config.customer === 'hpx' &&
          <div className={classes.legalNotesPanel} style={legalNoteStyle}>
            <p className={classes.legalNotesLabel}>
              <FormattedMessage {...messages.consumer_footer_text} />
            </p>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  nav: state.navReducer.nav,
  modals: state.modalReducer.modals,
  stories: state.storyReducer.stories,
  user: state.userReducer.user,
  accountSettings: state.storyReducer.accountSettings,
  selectionItems: state.selectionReducer && state.selectionReducer.selection.items,
  openStoryId: state.storyReducer.openStoryId,
  storyMoments: state.storyReducer.storyMoments,
  moments: state.storyReducer.moments,
  photoSwipeOpen: state.photoSwipeReducer.open
});

const NavComponent = withStyles(styles, { withTheme: true })(Nav);

export default connect(mapStateToProps, { showLoading, logOut, createStory, showNavBar, hideNavBar, showNavBarModal, showNavBarHome, showNavBarFeed, enableSelection, disableSelection, selectAll, unselectAll, setProgressBarVisible, setProgressBarTotal, setProgressBarProgress, setProgressBarMessage, resetProgressBar, showProfile, showStory })(NavComponent);
